import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { RedirectToMerchPage } from '../action-creators';
import { REDIRECT_TO_MERCH_PAGE } from '../actions';
import { push } from 'connected-react-router';

export const redirectToMerchPageEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, RedirectToMerchPage>(REDIRECT_TO_MERCH_PAGE),
    map((action) =>
      !action.route
        ? push(
            '/artist/page/merch'.concat(
              action.activeTab ? `?${action.activeTab}` : ''
            )
          )
        : push(action.route)
    )
  );
